export default {
    setSelectAppSettingData(state, data) {
        state.selectedAppSettingModel = data;
        state.selectAppSettingLoading = false;
    },
    setSelectAppSettingLoading(state, data) {
        state.selectAppSettingLoading = data;
    },
}